import React, { useState, useContext, useEffect } from 'react';
import AppContext from '../Context/AppContext';
import axios from 'axios';
import Loader from './Loader';
import Card from '../layout/Card';
import ReChartBar from '../libraries/ReChartBar';
import ReChartRadial from '../libraries/ReChartRadial';
import ReChartRadialBar from '../libraries/ReChartRadialBar';
import TableItems from '../libraries/TableItems';

const StatProjectInfo = ({ targetUrl, label }) => {
    const repeatTask = 1;
    const { mapUrl } = useContext(AppContext)
    const [load, setLoad] = useState(true)
    const [contentFilms, setContentFilms] = useState([])
    const [contentSeries, setContentSeries] = useState([])
    const [percentType, setPercentType] = useState(null);
    const [data, setData] = useState(null)

    const calculatePercentage = (filmsTotal, seriesTotal) => {
        const total = filmsTotal + seriesTotal;

        // Calcul du pourcentage
        const filmsPercentage = parseInt(((filmsTotal / total) * 100).toFixed(2));  // Arrondir à 2 décimales
        const seriesPercentage = parseInt(((seriesTotal / total) * 100).toFixed(2));

        // On crée le tableau avec les informations demandées
        const result = [
            {
                name: "Films",
                value: filmsPercentage,
                fill: filmsPercentage > seriesPercentage ? "#9754e3" : "#fff"  // Choisir la couleur en fonction du pourcentage
            },
            {
                name: "Series",
                value: seriesPercentage,
                fill: seriesPercentage > filmsPercentage ? "#9754e3" : "#fff"  // Choisir la couleur en fonction du pourcentage
            }
        ];

        return result;
    };

    const updateRanking = (newData, prevData) => {
        if (prevData.length > 0) {
            const previousRankMap = prevData.reduce((acc, item) => {
                acc[item.title] = item.classement;
                return acc;
            }, {});

            return newData.map((item, index) => {
                const previousRank = previousRankMap[item.title] || (index + 1);
                const changement = previousRank - (index + 1);
                return { ...item, classement: index + 1, changement };
            });
        } else {
            return newData.map((e, i) => ({ ...e, classement: i + 1, changement: null }));
        }
    };

    const init = async () => {
        if (mapUrl.hasOwnProperty(targetUrl)) {
            const response = await axios.get(mapUrl[targetUrl]);
            if (response?.data) {

                const films = response.data.films.items.slice(0, 20);
                const series = response.data.series.items.slice(0, 20);

                // Mise à jour des films et séries avec la fonction générique
                setContentFilms(prevFilms => updateRanking(films, prevFilms));
                setContentSeries(prevSeries => updateRanking(series, prevSeries));

                setPercentType(calculatePercentage(response.data.films.total, response.data.series.total))

                setData(response.data);
            }
        }
        setLoad(false);
    }



    const processData = (data) => {
        return data.map(item => {
            const value = parseFloat(item.percent); // Convertit "81.58%" → 81.58
            return { name: item.name, value };
        });
    };

    useEffect(() => {
        init();
        const interval = setInterval(init, repeatTask * 60 * 1000);
        return () => clearInterval(interval);
    }, [targetUrl])

    if (load) {
        return <div className='py2'>
            <Loader />
        </div>
    }
    return (
        <div className='pb2 stat-project-info'>
            <p className='cw fm fs18 mb1'>{label}</p>

            <div className='stat-grid mt1'>
                {data && (
                    <>
                        <Card addClass='bggrad'>
                            <ReChartBar label={"Versions"} data={processData(data.percentVersion)} />
                        </Card>
                        <Card addClass='bggrad'>
                            <ReChartBar label={"Méthode"} data={processData(data.percentMethod)} />
                        </Card>
                    </>
                )}
                <Card addClass='bggrad'>
                    <ReChartRadial label="Compte" data={[
                        { name: "Avec Compte", value: parseFloat(data.percentWithAccount.replace('%', '')), fill: parseFloat(data.percentWithAccount.replace('%', '')) < parseFloat(data.percentWithoutAccount.replace('%', '')) ? "#fff" : "#9556df" },
                        { name: "Sans Compte", value: parseFloat(data.percentWithoutAccount.replace('%', '')), fill: parseFloat(data.percentWithoutAccount.replace('%', '')) < parseFloat(data.percentWithAccount.replace('%', '')) ? "#fff" : "#9556df" }
                    ]} />
                </Card>
                <Card addClass='bggrad'>
                    <ReChartRadial label="Type" data={percentType} />
                </Card>
            </div>

            <div className='df gap1 mt1 block-stat-streaming-tems'>
                <div className='flex1'>
                    <TableItems label="Classement films" total={data.films.total} data={contentFilms} />
                </div>
                <div className='flex1'>
                    <TableItems label="Classement series" total={data.series.total} data={contentSeries} />
                </div>
            </div>

            <div className='stat-grid mt1'>
                <Card addClass='bggrad'>
                    <ReChartBar label={"Streamer films"} data={processData(data.films.percentStreamer)} />
                </Card>
                <Card addClass='bggrad'>
                    <ReChartBar label={"Streamer series"} data={processData(data.series.percentStreamer)} />
                </Card>

                {/** DEVICE OS & TYPE - GLOBAL */}
                {data.percentDeviceOs && (
                    <Card addClass='bggrad'>
                        <ReChartRadialBar label={"OS"} data={processData(data.percentDeviceOs)} />
                    </Card>
                )}
                {data.percentDeviceType && (
                    <Card addClass='bggrad'>
                        <ReChartRadial label={"Type d'appareil"} data={processData(data.percentDeviceType).map((d, i) => ({ ...d, fill: ['#9754e3', '#b07ce8', '#7c3aed', '#a78bfa', '#c4b5fd'][i % 5] }))} />
                    </Card>
                )}

                {/** DEVICE - FILMS */}
                {data.films.percentDeviceOs && (
                    <Card addClass='bggrad'>
                        <ReChartRadialBar label={"OS films"} data={processData(data.films.percentDeviceOs)} />
                    </Card>
                )}
                {data.films.percentDeviceType && (
                    <Card addClass='bggrad'>
                        <ReChartRadial label={"Appareil films"} data={processData(data.films.percentDeviceType).map((d, i) => ({ ...d, fill: ['#9754e3', '#b07ce8', '#7c3aed', '#a78bfa', '#c4b5fd'][i % 5] }))} />
                    </Card>
                )}

                {/** DEVICE - SÉRIES */}
                {data.series.percentDeviceOs && (
                    <Card addClass='bggrad'>
                        <ReChartRadialBar label={"OS séries"} data={processData(data.series.percentDeviceOs)} />
                    </Card>
                )}
                {data.series.percentDeviceType && (
                    <Card addClass='bggrad'>
                        <ReChartRadial label={"Appareil séries"} data={processData(data.series.percentDeviceType).map((d, i) => ({ ...d, fill: ['#9754e3', '#b07ce8', '#7c3aed', '#a78bfa', '#c4b5fd'][i % 5] }))} />
                    </Card>
                )}
            </div>

        </div>
    );
};

export default StatProjectInfo;